import BackspaceSVG from '../../assets/svg/backspace.svg';
export default BackspaceSVG;
